// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

document.addEventListener("turbolinks:load", function() {
  setTimeout(function () {
    let target = document.getElementById('flash-notice')

    target.style.transitionProperty = 'height, margin, padding'; /* [1.1] */
    target.style.transitionDuration = 400 + 'ms'; /* [1.2] */
    target.style.boxSizing = 'border-box'; /* [2] */
    target.style.height = flash.offsetHeight + 'px'; /* [3] */
  }, 7000);
})